<template>
  <div class="home">

    <!--  Home Text Start   -->
    <div class="home__text"  v-if="getHomeTextContent" v-for="textContent in getHomeTextContent">
      <h1 class="main-heading" :style="{'color': textContent.titlecolor}" v-if="textContent.showtitle">{{ textContent.title }}</h1>
      <div class="home__content" v-html="textContent.description"/>
      <!-- Horizontal Line -->
      <hr>
    </div>

    <!--  Home Counter Start   -->
    <template v-if="getTime && getCounterEventObj">
      <div class="current-event-section">
        <div class="current-event" :style="customStyle">
          <counter :date="getTime" :event-color="getColor" />
          <div class="current-event__data">
            <h1 class="current-event__title">{{ getCounterEventObj.title }} in {{ eventLocationTitle }}</h1>
            <a href="#" class="button button--primary" @click="openSelectedEvent">{{ $t('book-now') }}</a>
          </div>
        </div>
        <app-upcoming-events />
      </div>
    </template>

    <!--  Home Text Start   -->
      <div class="home__events normal-content" v-if="getHomeEventsContent" v-for="content in getHomeEventsContent">
        <card>
            <img :src="content.imagepath" :alt="content.title" class="home__events-img">
            <h2 class="home__events-title" :style="{'color': content.titlecolor}" v-if="content.showtitle">{{ content.title }}</h2>
            <div class="home__content" v-html="content.description"/>
        </card>
      </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AppUpcomingEvents from '@/components/AppUpcomingEvents.vue'

export default {
  name: 'Home',
  components: { AppUpcomingEvents },
  computed: {
    ...mapGetters('homeTextContent', ['getHomeTextContent', 'getHomeEventsContent']),
    ...mapGetters('counter', ['getCounterEventObj']),
    customStyle() {
      return {
        '--event-color': this.getColor
      }
    },
    getColor() {
      if (this.getCounterEventObj && this.getCounterEventObj.eventlocation) {
        return this.getCounterEventObj.eventlocation.color
      }
      return ''
    },
    getTime() {
      if (this.getCounterEventObj && this.getCounterEventObj.startdate && this.getCounterEventObj.starttime) {
        let { startdate: startDate, starttime: startTime } = this.getCounterEventObj;
        return (`${startDate} ${startTime}`)
      }
      return null
    },
    eventLocationTitle() {
      if (this.getCounterEventObj && this.getCounterEventObj.eventlocation) {
        return this.getCounterEventObj.eventlocation.title
      }
      return ''
    }
  },
  mounted() {
    this.fetchHomeTextContent()
    this.fetchCounterEvent()
  },
  methods: {
    ...mapActions('homeTextContent', ['fetchHomeTextContent']),
    ...mapActions('counter', ['fetchCounterEvent']),
    openSelectedEvent() {
      if (!this.getCounterEventObj || !this.getCounterEventObj.eventlocation) {
        return
      }
      // get event location id
      let { id: locationId } = this.getCounterEventObj.eventlocation;
      let { id: eventId } = this.getCounterEventObj;
      // go to route that match the same location and send over the event id via query params
      this.$router.push({
        name: 'Events',
        params: {id: locationId},
        query: { eventId }
      }).catch(() => {})
    }
  }
}
</script>

<style>
  .normal-content .home__content  {
    padding: 2.1rem;
  }
</style>
